const namespace = 'fn-advanced-analytics-deepar';

export default namespace;
